import { createApp } from 'vue'
import PrimeVue from 'primevue/config'

import SignInApp from '../src/SignInApp.vue'

const app = createApp(SignInApp)
app.use(PrimeVue, { ripple: true })
app.mount('#app')
